import { AirlineCompatibilityListing } from '@src/quince-site-common/src/domains/AirlineCompatibilityListing'

interface Listing {
  title: string
  compatibility: Record<string, boolean>
}

export const getTransformedACDataForUI = (acListings?: AirlineCompatibilityListing[]) => {
  const airlines = new Set<string>()
  const listings: Listing[] = []
  acListings?.forEach(acl => {
    const listing: Listing = { title: acl.title, compatibility: {} }
    acl.airlineCompatibilitySelections.forEach(ac => {
      airlines.add(ac.airlineName)
      listing.compatibility[ac.airlineName] = ac.compatibility
    })
    listings.push(listing)
  })
  return {
    airlines: Array.from(airlines).sort((a, b) => a.localeCompare(b)),
    listings,
  }
}
